import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import useMeasure from 'react-use-measure';
import { styles } from './viewerImgButton.styles';
import { getCommercialButton } from '~/utils/getCommercialButton';
import { motion } from 'framer-motion';
import { getTributeIcon } from '~/utils/getTributeIcon';
import { ResizeObserver } from '@juggle/resize-observer';
import { $isTributeButtonHovered } from '~/atoms/isTributeButtonHovered';
const Link = styled.a `
  ${styles}
`;
const Button = styled.button `
  ${styles}
  border: none;
  cursor: pointer;
`;
const ViewerImgButton = (props) => {
    const { category, status, isPaused, ...rest } = props;
    // Track the width of the link.
    // This is used to monitor the width of the parent container for rendering the label.
    const [ref, { width }] = useMeasure({ polyfill: ResizeObserver });
    const { label } = getCommercialButton(category);
    const icon = getTributeIcon(label);
    return icon && label ? (_jsxs(Link, { ...rest, ref: ref, style: {
            width: status === 'active' || isPaused ? '130px' : '40px',
            height: status === 'active' || isPaused ? '60px' : '40px',
        }, onMouseEnter: () => $isTributeButtonHovered.set(true), onMouseLeave: () => $isTributeButtonHovered.set(false), children: [_jsx(motion.div, { layout: "size", transition: {
                    duration: 0.4,
                    ease: 'easeInOut',
                }, children: icon }), (status === 'active' || isPaused) && width > 85 && (_jsx("span", { style: { width: '130px' }, className: "viewer-tribute-button-label", children: label }, label))] })) : null;
};
const ViewerPlanAheadButton = (props) => {
    const { category, status, isPaused, ...rest } = props;
    const [ref, { width }] = useMeasure({ polyfill: ResizeObserver });
    const { label } = getCommercialButton(category);
    const icon = getTributeIcon(label);
    return icon && label ? (_jsxs(Button, { ...rest, ref: ref, style: {
            width: status === 'active' || isPaused ? '130px' : '40px',
            height: status === 'active' || isPaused ? '60px' : '40px',
        }, onMouseEnter: () => $isTributeButtonHovered.set(true), onMouseLeave: () => $isTributeButtonHovered.set(false), children: [_jsx(motion.div, { layout: "size", transition: {
                    duration: 0.4,
                    ease: 'easeInOut',
                }, children: icon }), (status === 'active' || isPaused) && width > 85 && (_jsx("span", { style: { width: '130px' }, className: "viewer-tribute-button-label", children: label }, label))] })) : null;
};
export { ViewerImgButton, ViewerPlanAheadButton };
export default ViewerImgButton;
